var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"session-countdown text-right",class:{expiring: _vm.diff<60 && _vm.diff>0}},[_vm._v(" in "+_vm._s(_vm._f("twoDigits")(_vm.minutes))+":"+_vm._s(_vm._f("twoDigits")(_vm.seconds))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }